import clsx from "clsx";
import { cn } from "@/core/helpers/cn";
import { CrownIcon } from "@/shared/icons";

type Props = {
  idx: number;
  text: string;
  isActive?: boolean;
  number?: number;
  gradient?: string;
  onClick: (idx: number) => void;
};

export default function FactionRankItem({ idx, text, isActive, number, gradient, onClick }: Props) {
  return (
    <button
      type="button"
      className={cn(
        "relative flex items-center w-full h-12 py-[0.6875rem] pl-3 pr-4 border-b border-x border-[#2A2A2A] overflow-clip",
        idx === 0 && "border-t rounded-t-2xl",
      )}
      onClick={() => onClick(idx)}
    >
      <div
        className={cn(
          "absolute top-0 left-0 size-full transition-all duration-200",
          gradient,
          isActive ? "opacity-100" : "opacity-0",
        )}
      />
      {number && (
        <div
          className={clsx(
            "relative z-1 flex justify-center items-center size-6.5 mr-3.5 px-[0.4375rem] text-12 font-bold rounded-[0.4375rem] transition-all duration-200",
            isActive ? "text-black bg-white" : "text-accent-solid bg-accent-solid/50",
          )}
        >
          {number}
        </div>
      )}
      <p
        className={clsx(
          "relative z-1 text-14 font-medium leading-none transition-all duration-200",
          isActive ? "text-white" : "text-white/50",
        )}
      >
        {text}
      </p>
      {idx === 0 && <CrownIcon className="relative z-1 size-4 ml-auto" />}
    </button>
  );
}
